import ExecutiveReportsContainer from "./ExecutiveReportsContainer";

export default ExecutiveReportsContainer;
